var map = {
	"./doc.png": "1a35",
	"./docx.png": "0e24",
	"./file.png": "859e",
	"./jpeg.png": "4294",
	"./jpg.png": "309c",
	"./pdf.png": "7119",
	"./png.png": "2215",
	"./ppt.png": "5387",
	"./pptx.png": "a456",
	"./xls.png": "37bc",
	"./xlsx.png": "d1d2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "df9a";